module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/mortgage-insurance@2x-ce4814acf87f3589690a814bb16d0c4e.png";